export const translationsTh = {
  _hide: 'ซ่อน',
  _publish: 'เผยแพร่',
  _save: 'บันทึก',
  _open: 'เปิด',
  _close: 'ปิด',
  _delete: 'ลบ',
  _cancel: 'ยกเลิก',
  _from: 'จาก',
  _to: 'ถึง',
  _between_to: 'ถึง',
  _search: 'ค้นหา',
  _successful: 'บันทึกข้อมูลสำเร็จ',
  _clearSuccessful: 'ล้างข้อมูลสำเร็จ',
  _ok: 'ตกลง',
  _edit: 'แก้ไข',
  _confirm: 'ยืนยัน',
  _saveCompleted: 'บันทึกเรียบร้อยแล้ว',
  _saveFailed: 'บันทึกข้อมูลไม่สำเร็จ',
  _logout: 'ออกจากระบบ',
  _select: 'กรุณาเลือก',
  _upload_image: 'อัพโหลดรูป',
  _upload_image_recommend_spec: 'ขนาดรูปที่แนะนำ {image_size} และขนาดไฟล์ไม่เกิน {file_size}',
  _resize_image_recommend_spec: 'การขยายรูปอาจส่งผลต่อคุณภาพของรูป',
  _status: 'สถานะ',
  _clear: 'เคลียร์',
  _manual: 'คู่มือการใช้งาน',
  _click_here: 'คลิกที่นี่',
  _baht: 'บาท',
  _preview: 'ตัวอย่าง',
  _add: 'เพิ่ม',
  _import: 'นำเข้า',
  _sort: 'เรียงสินค้า',
  _sort_by: 'เรียงลำดับ',
  _move_to_top: 'ไปบนสุด',
  _move_to_bottom: 'ไปล่างสุด',
  _custom: 'กำหนดเอง',
  _pin: 'ปักหมุด',
  _unpin: 'เลิกปักหมุด',
  _learn_more: 'เรียนรู้เพิ่มเติม',
  _firstname: 'ชื่อ',
  _lastname: 'นามสกุล',
  _add_field: 'เพิ่มฟิลด์',
  _free: 'ฟรี',
  _product_name: 'ชื่อสินค้า',
  _data: 'ข้อมูล',
  _detail: 'รายละเอียด',
  _note: 'หมายเหตุ',
  _last_edited: 'แก้ไขล่าสุด',
  _by: 'โดย',
  product_buttons_label: 'รายการสินค้า',
  Unauthorized: '401: ไม่อนุญาตให้เข้าถึงหน้านี้',
  menu_product: 'สินค้า',
  menu_order: 'จัดการ',
  menu_settings: 'ตั้งค่า',
  menu_max_products: 'สินค้าสูงสุด',
  menu_max_products_unlimit: 'ไม่จำกัด',
  category: 'กลุ่มสินค้า',
  category_add: 'เพิ่มหมวดหมู่',
  category_parent_category: 'อยู่ภายใต้หมวดหมู่',
  category_detail: 'รายละเอียด',
  category_name: 'ชื่อหมวดหมู่',
  category_validate_please_insert_a_category_name: 'กรุณากรอกชื่อหมวดหมู่',
  category_staticURL: 'Static URL',
  order_from: 'สั่งซื้อจาก',
  order_ID: 'หมายเลขการสั่งซื้อ',
  order_date: 'วันที่สั่งซื้อ',
  order_shipping_address: 'ที่อยู่การจัดส่ง',
  order_name: 'ชื่อ',
  order_address: 'ที่อยู่',
  order_province: 'จังหวัด',
  order_country: 'ประเทศ',
  order_postcode: 'รหัสไปรษณีย์',
  order_tel: 'โทรศัพท์',
  order_email: 'อีเมล',
  order_billing_address: 'ที่อยู่ในการออกใบเสร็จ',
  order_product_details: 'รายละเอียด',
  order_product: 'สินค้า',
  order_price: 'ราคา',
  order_qty: 'จำนวน',
  order_total: 'ทั้งหมด',
  order_type: 'ประเภท',
  order_type_cart: 'สั่งซื้อ',
  order_type_contact: 'ติดต่อกลับ',
  order_subtotal: 'รวม',
  order_shipping: 'ค่าจัดส่ง',
  order_payment_method: 'วิธีการชำระเงิน',
  order_payment_method_Transfer: 'โอนเงิน',
  order_payment_method_omise: 'บัตรเครดิต',
  order_payment_method_kpayment_card: 'บัตรเครดิต',
  order_payment_method_kpayment_qr: 'คิวอาร์โค้ด',
  order_remask: 'หมายเหตุ',
  order_create_date: 'วันที่สร้าง',
  order_SKU: 'รหัสสินค้า',
  order_search_placeholder_select_date: 'ระบุวันที่ ...',
  order_contact_form: 'แบบฟอร์มตอบกลับ',
  products_management: 'จัดการสินค้า',
  products_setup: 'จัดการสินค้า',
  products_sorting: 'จัดเรียงสินค้า',
  products_management_sorting_options_select: 'เลือก',
  product_advance_search: 'เพิ่มเติม',
  product_advance_search_between: 'ระหว่าง',
  product_advance_search_please_select_one: 'กรุณาเลือก',
  product_advance_search_stock: 'สต๊อก',
  product_advance_search_price: 'ราคา',
  validatefail_price: 'กรุณากรอกเฉพาะตัวเลขและจุดทศนิยมไม่เกิน 2 ตำแหน่ง',
  validatefail_stock: 'กรุณากรอกเฉพาะตัวเลขเท่านั้น',
  validatefail_normal_price: 'ราคาปกติไม่ถูกต้อง',
  validatefail_member_price: 'ราคาสมาชิกไม่ถูกต้อง',
  validatefail_special_price: 'ราคาพิเศษไม่ถูกต้อง',
  validatefail_staticurl_dup: 'Static URL ซ้ำ',
  validatefail_staticurl_format: 'ใส่ Static URL ผิดรูปแบบ กรุณาใส่เฉพาะตัวอักษร, ตัวอักษรพร้อมตัวเลข หรือเครื่องหมาย - เท่านั้น และห้ามมีช่องว่าง',
  validatefail_productRelateSearch: 'กรุณากรอกชื่อสินค้ามากกว่า 1 ตัวอักษร',
  validatefail_weight: 'น้ำหนักไม่ถูกต้อง',
  validatefail_normal_price_lower_than_special: 'ราคาปกติต้องมากกว่าราคาพิเศษ',
  validatefail_normal_price_lower_than_member: 'ราคาปกติต้องมากกว่าราคาสมาชิก',
  validatefail_special_price_greater_than_normal: 'ราคาพิเศษต้องไม่มากกว่าราคาปกติ',
  validatefail_member_price_greater_than_normal: 'ราคาสมาชิกต้องไม่มากกว่าราคาปกติ',
  validatefail_special_and_member_price_greater_than_normal: 'ราคาพิเศษและราคาสมาชิกต้องไม่มากกว่าราคาปกติ',
  modal_confirm_del: 'ยืนยันการลบข้อมูล',
  modal_confirm_del_contact_form: 'ยืนยันการลบข้อมูล',
  modal_confirm_del_contact_form_field: 'ยืนยันการลบข้อมูล',
  modal_confirm_del_field: 'ยืนยันการลบข้อมูล',
  modal_confirm_del_payment_field: 'ยืนยันการลบข้อมูล',
  modal_confirm_del_velaeasy_sections: 'สินค้านี้มีการเพิ่ม Section ไว้ที่ระบบ R-Web หากลบสินค้านี้ Section ที่เคยเพิ่มไว้จะถูกลบไปด้วย <br><br> ยืนยันการลบข้อมูล',
  modal_confirm_del_shipping_type: 'ยืนยันการลบข้อมูล',
  modal_delete_category_dialog_velaeasy_sections: 'กลุ่มสินค้านี้มีการเพิ่ม Section ไว้ที่ระบบ R-Web หากลบกลุ่มสินค้านี้ Section ที่เคยเพิ่มไว้จะถูกลบไปด้วย <br><br> คุณต้องการ <b>ลบ</b> กลุ่มสินค้า <i>{name}</i>? <br>การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  modal_confirm_del_cate: 'ยืนยันการลบหมวดหมู่',
  modal_confirm: 'ยืนยัน',
  modal_cancel: 'ยกเลิก',
  modal_success: 'ตกลง',
  modal_success_del: 'ลบข้อมูลเรียบร้อยแล้ว',
  modal_success_del_contact_form: 'ลบข้อมูลเรียบร้อยแล้ว',
  modal_success_del_field: 'ลบข้อมูลเรียบร้อยแล้ว',
  modal_success_del_payment_field: 'ลบข้อมูลเรียบร้อยแล้ว',
  modal_success_del_shipping_type: 'ลบข้อมูลเรียบร้อยแล้ว',
  modal_error_occured: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
  modal_fail_apply_all: 'ไม่สามารถนำราคาปกติที่ว่างไปใช้ในหน้านี้ได่้',
  modal_fail: 'กรุณาตรวจสอบ ข้อมูลสินค้าอีกครั้ง',
  modal_fail_processing_static_url_input: 'ระบบกำลังตรวจสอบข้อมูลชื่อ Static URL โปรดลองใหม่อีกครั้ง',
  modal_fail_processing_sku_input: 'ระบบกำลังตรวจสอบข้อมูลรหัสสินค้า โปรดลองใหม่อีกครั้ง',
  modal_cancel_update: 'คุณกำลังปิดหน้าต่างโดยไม่บันทึก,คุณต้องการบันทึกข้อมูลหรือไม่?',
  modal_dont_save: 'ไม่บันทึก',
  modal_apply_to_all: 'ใช่ เปลี่ยนแปลงทั้งหมด',
  modal_delete: 'ต้องการลบรูปดังกล่าว?',
  modal_image_limit: 'คุณสามารถที่จะเพิ่มรูปสินค้าได้มากสุด',
  modal_image_items: 'รายการ',
  modal_image_crop_limit: 'สามารถอัพโหลดรูปภาพได้ครั้งละ 1 รูปเท่านั้น',
  modal_disabled_product_variants: 'กรุณาบันทึกสินค้าก่อนใช้งานในส่วนนี้',
  modal_confirm_generate: 'ยืนยันการสร้างคุณสมบัติสินค้า?',
  modal_confirm_generate_alert: 'คุณสมบัติเดิมจะถูกลบและสร้างใหม่',
  modal_generating: 'โปรดรอสักครู่ ระบบกำลังทำการสร้างคุณสมบัติสินค้า',
  modal_processing: 'กำลังดำเนินการ',
  modal_generate_complete: 'สร้างคุณสมบัติสินค้า เสร็จเรียบร้อย',
  modal_delete_product_var: 'คุณต้องการลบ คุณสมบัติสินค้าหรือไม่ ?',
  modal_delete_category_title: 'ลบกลุ่มสินค้า',
  modal_delete_category_dialog: 'คุณต้องการ <b>ลบ</b> กลุ่มสินค้า <i>{name}</i>? <br>การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  modal_delete_category_cancel: 'ยกเลิก',
  modal_delete_category_confirm: 'ลบ',
  modal_delete_category_fail: 'ไม่สามารถลบข้อมูล เนื่องจากมีหมวดหมู่ย่อย หรือสินค้าอยู่ภายใต้หมวดหมู่นี้',
  modal_delete_relate: 'ต้องการลบสินค้าที่เกี่ยวข้องหรือไม่?',
  modal_title_delete: 'ลบข้อมูล',
  modal_fail_del: 'ไม่สามารถลบได้ เนื่องจากมีสินค้า หรือหมวดหมู่ย่อยอยู่',
  modal_title_logout: 'ออกจากระบบ',
  modal_title_clear: 'ล้างข้อมูล',
  modal_clear: 'คุณต้องการล้างข้อมูลเหล่านี้หรือไม่?',
  modal_logout: 'ต้องการออกจากระบบ ?',
  modal_title_warning: 'แจ้งเตือน',
  modal_currency_not_support_some_payments: 'ต้องการใช้สกุลเงินนี้ และปิดระบบชำระเงินที่ไม่รองรับหรือไม่?',
  modal_quota_rpshop_products: 'แพ็กเกจที่คุณใช้ไม่สามารถเพิ่มสินค้าได้อีก ต้องการอัพเกรดแพ็กเกจหรือไม่',
  modal_quota_rpshop_product_variants: 'แพ็กเกจที่คุณใช้ไม่สามารถเพิ่มตัวเลือกย่อยของสินค้าได้ ต้องการอัพเกรดแพ็กเกจหรือไม่',
  modal_quota_contact_form: 'แพ็กเกจที่คุณใช้ไม่สามารถตั้งค่าแบบฟอร์มตอบกลับได้ ต้องการอัพเกรดแพ็กเกจหรือไม่',
  modal_confirm_to_toggle_all_country: 'ประเทศทั้งหมดที่คุณเลือกไว้จะถูกลบ ต้องการดำเนินการต่อหรือไม่?',
  modal_confirm_delete_shipping_region: 'ยืนยันการลบข้อมูลพื้นที่จัดส่งนี้?',
  modal_delete_shipping_region_success: 'ลบข้อมูลพื้นที่จัดส่งเรียบร้อยเเล้ว',
  product_list_total: 'รายการทั้งหมด {total} รายการ',
  product_list_add_product: 'เพิ่มสินค้า',
  product_list_name: 'ชื่อ',
  product_list_normal_price: 'ราคาปกติ',
  product_list_member_price: 'ราคาสมาชิก',
  product_list_special_price: 'ราคาพิเศษ',
  product_list_image: 'รูปสินค้า',
  product_list_stock: 'สต๊อก',
  product_list_status: 'สถานะสินค้า',
  product_list_status_show: 'แสดง',
  product_list_status_hide: 'ซ่อน',
  product_list_status_show_member: 'แสดงเฉพาะสมาชิก',
  product_list_action: 'จัดการสินค้า',
  product_list_search_product_not_found: 'ไม่พบสินค้า',
  product_list_search_please_fill_keyword: 'กรุณากรอกคำค้นหามากกว่า 1 ตัวอักษร หรือระบุราคา/สต๊อก',
  product_list_search_please_fill_correct_price: 'กรุณากรอกราคาให้ถูกต้อง',
  product_list_category_deleted_complete: 'ลบหมวดหมู่สินค้าสำเร็จ',
  product_list_category_cannot_deleted: 'ไม่สามารถลบหมวดหมู่สินค้าได้',
  product_info_add_product: 'เพิ่มสินค้า',
  product_info_edit_product: 'แก้ไขสินค้า',
  product_info_basic_setting: 'ตั้งค่าเบื้องต้น',
  product_info_product_variants: 'ตัวเลือกย่อย',
  product_basic_setting_image: 'รูปภาพ',
  product_basic_setting_add_product_relate: 'เพิ่ม สินค้าที่เกี่ยวข้อง',
  product_basic_setting_relate_add_product: 'เพิ่ม สินค้า',
  product_basic_setting_name: 'ชื่อสินค้า',
  product_basic_setting_SKU: 'รหัสสินค้า',
  product_basic_setting_relate_search_product_name_n_sku: 'ชื่อสินค้า, รหัสสินค้า',
  product_basic_setting_select_a_contact_form: 'เลือกแบบฟอร์มติดต่อกลับ',
  product_basic_setting_validate_product_name_required: 'กรุณาใส่ชื่อสินค้า',
  product_basic_setting_validate_contact_form_required: 'กรุณาเลือกแบบฟอร์มติดต่อกลับ',
  product_basic_setting_validate_product_limit: 'กรุณาใส่ชื่อสินค้าขนาดไม่เกิน 200 ตัวอักษร',
  product_basic_setting_detail: 'รายละเอียดสินค้า',
  product_basic_setting_normal_price: 'ราคา',
  product_basic_setting_original_price: 'ราคาปกติ',
  product_basic_setting_special_price: 'ราคาพิเศษ',
  product_basic_setting_member_price: 'ราคาสมาชิก',
  product_basic_setting_discount_percentage: 'ลด {percent} % จากราคาปกติ',
  product_basic_setting_staticURL: 'Static URL',
  product_basic_setting_stock: 'สต๊อก',
  product_basic_setting_status: 'สถานะสินค้า',
  product_basic_setting_status_show: 'แสดง',
  product_basic_setting_status_hide: 'ซ่อน',
  product_basic_setting_status_show_only_members: 'แสดงเฉพาะสมาชิก',
  product_basic_setting_product_group: 'หมวดหมู่',
  product_basic_setting_relate_search_no_result: 'ไม่พบผลลัพธ์',
  product_basic_setting_related_product: 'สินค้าที่เกี่ยวข้อง',
  product_basic_setting_related_products: 'สินค้าที่เกี่ยวข้อง',
  product_basic_setting_validate_sku_required: 'กรุณาใส่รหัสสินค้า',
  product_basic_setting_validate_sku_duplicate: 'รหัสสินค้า ซ้ำ',
  product_basic_setting_validate_sku_limit: 'กรุณาใส่รหัสสินค้าขนาดไม่เกิน 255 ตัวอักษร',
  product_basic_setting_validate_sku_specialchar: 'ไม่อนุญาตให้ใช้อักขระพิเศษ',
  product_basic_setting_order_style: 'รูปแบบการสั่งซื้อ',
  product_basic_setting_order_style_buy_now_button: 'ปุ่มสั่งซื้อ',
  product_basic_setting_order_style_contact_form: 'แบบฟอร์มติดต่อกลับ',
  product_basic_setting_order_style_hide_quantity_selection: 'ไม่แสดงตัวเลือกจำนวนสินค้า',
  product_basic_setting_order_style_hide_price: 'ซ่อนราคา',
  product_basic_setting_weight: 'น้ำหนัก (กรัม)',
  product_basic_setting_label: 'ป้ายกำกับ',
  product_basic_setting_product_label_new: 'ใหม่ล่าสุด',
  product_basic_setting_product_label_best_seller: 'ขายดี',
  product_basic_setting_product_label_recommended: 'แนะนำ',
  product_variant_attribute: 'คุณสมบัติของสินค้า',
  product_variant_attribute_values: 'ตัวเลือกของสินค้า',
  product_variant_generate: 'สร้าง คุณสมบัติสินค้า',
  product_variant_selectall: 'เลือกทั้งหมด',
  product_variant_name: 'ชื่อ',
  product_variant_image: 'รูปภาพ',
  product_variant_normal_price: 'ราคาปกติ',
  product_variant_special_price: 'ราคาพิเศษ',
  product_variant_member_price: 'ราคาสมาชิก',
  product_variant_stock: 'สต๊อก',
  product_variant_status: 'สถานะ',
  product_variant_action: 'จัดการ',
  product_variant_weight: 'น้ำหนัก',
  product_variant_weight_g: 'กรัม',
  product_variant_weight_tips: 'หากเป็นค่าว่าง ระบบจะใช้น้ำหนักของสินค้าหลักที่ตั้งค่าไว้',
  product_variant_validate_weight_incorrect: 'กรุณากรอกเฉพาะตัวเลข',
  product_variant_validate_weight_limit_exceed: 'กรุณากรอกน้ำหนักไม่เกิน {limit}',
  product_variant_validate_stock_incorrect: 'กรุณากรอกเฉพาะตัวเลข',
  product_variant_validate_sku_required: 'กรุณาใส่รหัสสินค้า',
  product_variant_validate_sku_duplicate: 'รหัสสินค้า ซ้ำ',
  product_variant_validate_sku_limit: 'กรุณาใส่รหัสสินค้าขนาดไม่เกิน 255 ตัวอักษร',
  product_variant_status_show: 'แสดง',
  product_variant_status_hide: 'ซ่อน',
  product_variant_status_out: 'สินค้าหมด',
  product_variant_delete: 'ลบ',
  product_variant_selected: 'เลือก:',
  product_variant_deleteall: 'ลบทั้งหมด',
  product_variant_placeholder_attr: 'เช่น  ขนาดไซส์',
  product_variant_product_attribute_add_a_tag: 'เช่น  S, M, L',
  product_variant_placeholder_color_attr: 'เช่น  สี',
  product_variant_product_attribute_color_add_a_tag: 'เช่น  แดง, เขียว, น้ำเงิน',
  product_variant_placeholder_type_attr: 'เช่น  ประเภท',
  product_variant_product_attribute_type_add_a_tag: 'เช่น  เสื้อยืด, เสื้อโปโล, เสื้อเชิ้ต',
  product_variant_SKU: 'รหัสสินค้า',
  product_variant_update_success: 'อัพเดตข้อมูลสำเร็จ',
  product_variant_popper_apply_to_all: 'เปลี่ยนแปลงทั้งหมดบนหน้านี้',
  product_variant_apply_to_all_question: 'ต้องการเปลี่ยนแปลง {field} ทั้งหมด?',
  product_variant_attribute_generate_error: 'กรุณากรอกข้อมูลให้ครบก่อนทำการสร้างสินค้าใหม่',
  product_variant_attribute_generate_title: 'ยืนยันการสร้างสินค้า',
  product_variant_attribute_generate_message: 'สินค้าเก่าจะถูกลบทั้งหมด และสร้างสินค้าใหม่',
  product_variant_attribute_generate_add_success: 'บันทึกสินค้าสำเร็จ',
  product_variant_attribute_generate_add_error: 'ไม่สามารถสร้างสินค้าได้',
  product_variant_attribute_generate_add_error_or_limit_over_1000: 'ไม่สามารถสร้างตัวเลือกย่อยได้มากกว่า 1,000 ชิ้น',
  product_variant_attribute_not_allow_brackets: 'ไม่รองรับอักขระ "[" และ "]"',
  currency_settings: 'สกุลเงิน',
  setting: 'ตั้งค่า',
  setting_currency: 'การแสดงผลสกุลเงิน',
  setting_currency_iso: 'ISO 4217 Currency Code',
  setting_currency_iso_validate_required: 'กรุณาเลือกสกุลเงิน',
  setting_currency_custom: 'กำหนดเอง',
  setting_currency_custom_validate_required: 'กรุณากรอกสกุลเงินที่ต้องการ',
  setting_currency_custom_validate_limit: 'สกุลเงินไม่ควรเกิน 10 ตัวอักษร',
  setting_currency_preview: 'ตัวอย่าง',
  setting_currency_prefix: 'หน้า',
  setting_currency_suffix: 'หลัง',
  shipping_settings: 'ค่าขนส่ง',
  shipping_settings_delete: 'ลบ',
  shipping_settings_add: 'เพิ่มพื้นที่จัดส่ง',
  shipping_settings_empty_list: 'ไม่พบรายการค่าขนส่ง',
  shipping_settings_delete_title: 'ลบรายการค่าขนส่ง',
  shipping_settings_delete_dialog: 'ต้องการ <b>ลบ</b> รายการค่าขนส่งนี้ ?',
  shipping_settings_edit_title: 'จัดการค่าขนส่ง',
  shipping_settings_toast_save_complete: 'บันทึกข้อมูลเรียบร้อยแล้ว',
  shipping_settings_toast_delete_complete: 'ลบข้อมูลเรียบร้อยแล้ว',
  shipping_validate_name_failed: 'กรุณากรอกชื่อค่าขนส่ง',
  shipping_validate_name_failed_limit: 'กรุณาใส่ชื่อค่าขนส่งขนาดไม่เกิน 100 ตัวอักษร',
  shipping_validate_price_failed: 'กรุณากรอกราคาค่าขนส่งเป็นตัวเลข',
  shopping_cart_text_settings: 'ข้อความในตะกร้า',
  shopping_cart_text_settings_cart: 'ตะกร้าสินค้า',
  shopping_cart_text_settings_thankyou: 'หน้าขอบคุณ',
  shopping_cart_text_settings_cancel: 'ยกเลิกการแก้ไขข้อมูล',
  shopping_cart_text_settings_cancel_message: 'ข้อมูลที่ไม่ได้บันทึกจะสูญหาย ต้องการดำเนินการต่อหรือไม่?',
  payment_settings: 'การชำระเงิน',
  payment_settings_validate_omise_public_key: 'กรุณากรอก public key',
  payment_settings_validate_omise_secret_key: 'กรุณากรอก secret key',
  payment_settings_validate_paypal_client_id: 'กรุณากรอก client id',
  payment_settings_validate_paypal_secret: 'กรุณากรอก secret',
  payment_settings_validate_transfer_manual_text: 'กรุณากรอกข้อความกำหนดเอง',
  payment_settings_validate_custom_text: 'กรุณากรอกข้อความ',
  payment_settings_validate_kpayment_merchant_id: 'กรุณากรอก Merchant ID',
  payment_settings_validate_kpayment_public_key: 'กรุณากรอก Public key',
  payment_settings_validate_kpayment_secret_key: 'กรุณากรอก Secret key',
  payment_settings_currency: 'สกุลเงิน',
  payment_settings_currency_not_support: 'ไม่สามารถเปิดใช้งานระบบชำระเงินนี้กับสกุลเงินที่เลือกได้',
  payment_settings_currency_display: 'การแสดงผล',
  payment_settings_currency_position: 'ตำแหน่ง',
  payment_settings_currency_symbol: 'สัญลักษณ์',
  payment_settings_currency_prefix: 'หน้า',
  payment_settings_currency_suffix: 'หลัง',
  payment_settings_transfer: 'โอนเงิน',
  payment_settings_transfer_title: 'การโอนเงิน',
  payment_settings_transfer_text: 'ข้อความที่แสดง',
  payment_settings_transfer_custom: 'กำหนดเอง',
  payment_settings_transfer_edit: 'แก้ไขการโอนเงิน',
  payment_settings_omise_edit: 'แก้ไข Omise',
  payment_settings_paypal_edit: 'แก้ไข PayPal',
  payment_settings_credit_card_edit: 'แก้ไข บัตรเครดิต',
  payment_settings_qr_code_edit: 'แก้ไข คิวอาร์โค้ด',
  payment_settings_kpayment_card_edit: 'แก้ไข K-Payment Gateway',
  payment_settings_kpayment_use_same_config: 'การตั้งค่านี้จะมีผลกับทั้งการชำระเงินผ่านบัตรเครดิตและคิวอาร์โค้ด',
  payment_settings_kpayment_use_with_bank: 'ใช้สมัครบริการกับทางธนาคาร',
  payment_settings_kpayment_system_info: 'ข้อมูลเฉพาะของระบบ',
  payment_settings_kpayment_system_info_email: 'อีเมลทีมพัฒนา',
  payment_settings_manual: 'กำหนดเอง',
  payment_settings_title: 'ตั้งค่าการชำระเงิน',
  payment_settings_display_title: 'วิธีการชำระเงิน',
  payment_settings_edit_to_connect: 'เพื่อเชื่อมต่อ',
  payment_settings_as_a_payment_method: 'เป็นวิธีการชำระเงิน กรุณากรอกข้อมูลให้สมบูรณ์',
  payment_settings_as_a_payment_method_please_choose: 'เป็นวิธีการชำระเงิน กรุณาเลือกข้อความ',
  payment_settings_custom_text: 'ข้อความ',
  payment_settings_custom_icon: 'สัญลักษณ์',
  payment_settings_custom_no_icon: 'ไม่ใช้',
  payment_settings_field_limit_5: 'เพิ่มตัวเลือกได้สูงสุด 5 ตัวเลือก',
  export_order_error_title: 'การส่งออกข้อมูลไม่สำเร็จ',
  export_order_error_content: 'ไม่พบรายการสั่งซื้อหรือจำนวนของข้อมูลมีมากกว่า1000รายการ',
  export_order_confirm_title: 'ยืนยันการส่งออกรายการสั่งซื้อ',
  export_order_default: 'ส่งออกรายการสั่งซื้อทั้งหมด',
  export_order_date1: 'วันที่เริ่มต้น',
  export_order_date2: 'วันที่สิ้นสุด',
  export_order_keyword: 'คำค้นหา',
  export_order_create_date: 'วันที่สร้าง',
  export_order_update_date: 'วันที่สั่งซื้อ',
  export_order_type: 'ประเภท',
  export_order_status: 'สถานะ',
  cc_email_settings: 'อีเมลร้านค้า',
  cc_email_settings_send_order_email_to_address: 'ส่งอีเมลการสั่งซื้อไปยังอีเมลเหล่านี้',
  cc_email_settings_main_email: 'อีเมลหลัก',
  cc_email_settings_cc_email_1: 'สำเนาอีเมล 1',
  cc_email_settings_cc_email_2: 'สำเนาอีเมล 2',
  cc_email_settings_cc_email_3: 'สำเนาอีเมล 3',
  cc_email_settings_cc_email_4: 'สำเนาอีเมล 4',
  cc_email_settings_validate_required: 'กรุณากรอกอีเมลหลัก',
  cc_email_settings_validate_invalid: 'ใส่อีเมลผิดรูปแบบ',
  cc_email_settings_validate_duplicate: 'อีเมลซ้ำ',
  order_custom_form_settings: 'แบบฟอร์มการสั่งซื้อ',
  order_custom_form_settings_title: 'ตั้งค่าแบบฟอร์ม',
  order_custom_form_display_title: 'ข้อมูลการสั่งซื้อเพิ่มเติม',
  order_custom_form_required_field: 'จำเป็น',
  order_custom_form_option_field: 'ไม่จำเป็น',
  order_details_custom_form: 'ข้อมูลการสั่งซื้อเพิ่มเติม',
  order_details_contact_form: 'ข้อมูลแบบฟอร์มตอบกลับ',
  order_custom_form_option_field_limit: 'เพิ่มตัวเลือกได้สูงสุด {limit} ตัวเลือก',
  order_custom_form_attachment_field_limit: 'เพิ่มไฟล์แนบได้สูงสุด {limit} ฟิลด์',
  order_custom_form_label: 'ชื่อ',
  order_custom_form_field_type: 'ประเภท',
  order_custom_form_text: 'ข้อความ',
  order_custom_form_dropdown: 'รายการเลือก',
  order_custom_form_require: 'จำเป็น',
  order_custom_form_dropdown_options: 'ตัวเลือก',
  order_custom_form_text_placeholder: 'ตัวอย่างข้อความ',
  order_custom_form_dropdown_append: 'เพิ่ม',
  order_custom_form_dropdown_replace: 'แทนที่',
  order_custom_form_no_item: 'ไม่มีตัวเลือก',
  order_custom_form_plase_upload_csv_file: 'กรุณาอัพโหลดไฟล์ csv',
  order_custom_form_setting_not_found: 'ไม่พบแบบฟอร์ม',
  order_custom_form_option_is_null: 'ข้อมูลว่าง',
  order_custom_form_option_over: 'ข้อมูลเกิน {limit} รายการ',
  order_custom_form_please_insert_label: 'กรุณากรอกชื่อ',
  order_custom_form_please_add_options: 'กรุณาเพิ่มตัวเลือก',
  order_custom_form_option_character_over: 'บางตัวเลือกมีขนาดมากกว่า {limit} ตัวอักษร',
  order_custom_form_option_duplicate: 'ตัวเลือกซ้ำ',
  order_custom_form_datetime_show_time: 'แสดงเวลา',
  update_products_sorting_toast_complete: 'บันทึกสำเร็จ',
  update_products_sorting_toast_error: 'เกิดข้อผิดพลาด! โปรดลองใหม่ภายหลัง',
  category_products_sort_label: 'เรียงตาม',
  sort_options_custom: 'กำหนดเอง',
  sort_options_newest: 'ใหม่ที่สุด',
  sort_options_oldest: 'เก่าที่สุด',
  sort_options_a_to_z: 'ก-ฮ',
  sort_options_z_to_a: 'ฮ-ก',
  sort_options_highest_price: 'ราคามากที่สุด',
  sort_options_lowest_price: 'ราคาน้อยที่สุด',
  sort_options_confirm_title: 'เรียงสินค้าทั้งหมด',
  sort_options_confirm_detail: 'กระบวนการนี้จะ <b>ปรับปรุง</b> ลำดับการเรียงสินค้าล่าสุดของคุณ ต้องการดำเนินการต่อหรือไม่?',
  no_sub_category: 'ไม่มีหมวดหมู่สินค้าย่อย',
  pinned_products_sortable_hint: 'สินค้าที่ปักหมุดแล้วสามารถลากย้ายได้',
  all_products_sort_label: 'เรียงสินค้าทั้งหมด',
  unpin_product_title: 'เลิกปักหมุด',
  unpin_product_dialog: 'ต้องการเลิกปักหมุดสินค้านี้?',
  contact_form_settings: 'แบบฟอร์มติดต่อกลับ',
  contact_form_settings_title: 'ตั้งค่าแบบฟอร์ม',
  contact_form_setting_not_found: 'ไม่พบแบบฟอร์ม',
  contact_form_name: 'ชื่อ',
  contact_form_please_insert_name: 'กรุณากรอกชื่อ',
  contact_form_settings_field: 'ตั้งค่าแบบฟอร์ม',
  contact_form_setting_field_not_found: 'ไม่พบแบบฟอร์ม',
  contact_form_display_title: 'แบบฟอร์ม',
  contact_form_settings_detail: 'ติดต่อกับลูกค้าก่อนการสั่งซื้อ',
  contact_form_setting_untitle: 'ไม่มีหัวข้อ',
  contact_form_setting_create: 'สร้างแบบฟอร์มติดต่อกลับ',
  contact_form_label: 'ชื่อ',
  contact_form_please_insert_label: 'กรุณากรอกชื่อ',
  contact_form_please_insert_text: 'กรุณากรอกข้อความ',
  contact_form_field_type: 'ประเภท',
  contact_form_text: 'ข้อความ',
  contact_form_email: 'อีเมล',
  contact_form_tel: 'เบอร์โทรศัพท์',
  contact_form_dropdown: 'รายการเลือก',
  contact_form_textarea: 'กล่องข้อความ',
  contact_form_checkbox: 'เลือกได้หลายตัวเลือก',
  contact_form_radio: 'เลือกได้ 1 ตัวเลือก',
  contact_form_attachment: 'ไฟล์แนบ',
  contact_form_date: 'วัน',
  contact_form_datetime: 'วัน-เวลา',
  contact_form_text_placeholder: 'ตัวอย่างข้อความ',
  contact_form_dropdown_options: 'ตัวเลือก',
  contact_form_no_item: 'ไม่มีตัวเลือก',
  contact_form_require: 'จำเป็น',
  contact_form_option_over: 'ข้อมูลเกิน {limit} รายการ',
  contact_form_option_duplicate: 'ตัวเลือกซ้ำ',
  contact_form_please_add_options: 'กรุณาเพิ่มตัวเลือก',
  contact_form_dropdown_append: 'เพิ่ม',
  contact_form_dropdown_replace: 'แทนที่',
  contact_form_option_character_over: 'บางตัวเลือกมีขนาดมากกว่า {limit} ตัวอักษร',
  contact_form_option_is_null: 'ข้อมูลว่าง',
  contact_form_plase_upload_csv_file: 'กรุณาอัพโหลดไฟล์ csv',
  contact_form_setting_button_contact: 'ติดต่อ',
  contact_form_setting_button_reserve: 'จอง',
  contact_form_setting_button_buy_now: 'สั่งซื้อ',
  contact_form_settings_button: 'ปุ่มบันทึก',
  contact_form_button_icon: 'สัญลักษณ์',
  contact_form_button_no_icon: 'ไม่ใช้สัญลักษณ์',
  contact_form_option_field_limit: 'เพิ่มตัวเลือกได้สูงสุด {limit} ตัวเลือก',
  contact_form_attachment_field_limit: 'เพิ่มไฟล์แนบได้สูงสุด {limit} ฟิลด์',
  contact_form_datetime_show_time: 'แสดงเวลา',
  form_settings: 'แบบฟอร์ม',
  form_settings_detail: 'สร้างฟอร์มเพื่อให้ลูกค้ากรอกข้อมูลเมื่อสั่งซื้อหรือติดต่อ',
  form_settings_shipping: 'สร้างรูปแบบการขนส่ง',
  shipping_region_settings_back_to_list_of_regions: 'กลับ',
  shipping_region_settings_shipping_region: 'พื้นที่จัดส่ง',
  shipping_region_settings_add_country_in_this_region: 'เพิ่มประเทศในพื้นที่นี้',
  shipping_region_settings_shipping_type: 'ประเภทการขนส่ง',
  shipping_region_settings_add_shipping_type_in_this_region: 'เพิ่มประเภทการขนส่งในพื้นที่นี้',
  shipping_region_settings_add_shipping_type: 'เพิ่มประเภทการขนส่ง',
  shipping_estimate_delivery_time: 'ระยะเวลาจัดส่งสินค้า',
  shipping_estimate_delivery_time_placeholder: 'ตัวอย่าง: 2 - 10 วันทำการ',
  shipping_name: 'ชื่อ',
  shipping_name_placeholder: 'ตัวอย่าง: ฟรีค่าจัดส่ง',
  shipping_description: 'รายละเอียดการส่งสินค้า',
  shipping_description_placeholder: 'ตัวอย่าง: ฟรีค่าจัดส่ง เมื่อสั่งซื้อสินค้าตามเงื่อนไขที่กำหนด',
  shipping_limit_input: 'จำกัดตัวอักษร {limit} ตัว',
  shipping_type: 'การจัดส่ง',
  shipping_type_free_shipping: 'ฟรีค่าจัดส่ง',
  shipping_description_free_shipping: 'ไม่คิดค่าจัดส่งกับลูกค้า',
  shipping_type_flat_rate: 'ระบุค่าจัดส่ง',
  shipping_description_flat_rate: 'ใช้ค่าจัดส่งนี้ทุกรายการสั่งซื้อ',
  shipping_type_rate_by_quantity: 'ค่าจัดส่งตามจำนวน',
  shipping_description_rate_by_quantity: 'คำนวณค่าจัดส่งตามจำนวนสินค้าในรายการสั่งซื้อ',
  shipping_type_rate_by_weight: 'ค่าจัดส่งตามน้ำหนัก',
  shipping_description_rate_by_weight: 'คำนวณค่าจัดส่งตามน้ำหนักของสินค้าในรายการสั่งซื้อ',
  shipping_type_external: 'แยกชำระค่าจัดส่ง',
  shipping_description_external: 'คิดค่าจัดส่งเพิ่มเติมหลังจากการสั่งซื้อ',
  shipping_shop_free: 'ฟรี',
  region_country_selector: 'เลือกประเทศ',
  all_country: 'ทุกประเทศยกเว้นประเทศที่ระบุไว้ในพื้นที่จัดส่ง',
  add_country: '+ เพิ่มประเทศ',
  select_country: 'เลือกประเทศ',
  no_country_result: 'ไม่พบประเทศที่ค้นหา',
  shipping_region_limit_over: 'เพิ่มพื้นที่จัดส่งได้สูงสุด {limit} พื้นที่',
  shipping_settings_free_order: 'ฟรีค่าจัดส่ง เมื่อสั่งซื้อสินค้ามากกว่า {rate}',
  shipping_offer_free_shipping: 'ฟรีค่าจัดส่ง เมื่อมูลค่ารวมมากกว่า',
  shipping_item_limit_over: 'เพิ่มประเภทการขนส่งได้สูงสุด {limit}',
  shipping_quantity_range: 'ช่วงจำนวนสินค้า',
  shipping_weight_range: 'ช่วงน้ำหนักสินค้า (กรัม)',
  shipping_rate: 'ค่าจัดส่ง',
  shipping_add_range: 'เพิ่มช่วง',
  shipping_invalid_weight_data: 'ช่วงน้ำหนักสินค้าไม่ถูกต้อง และ ค่าจัดส่งไม่ถูกต้อง',
  shipping_invalid_quantity_data: 'ช่วงจำนวนสินค้าไม่ถูกต้อง และ ค่าจัดส่งไม่ถูกต้อง',
  shipping_invalid_quantity_range: 'ช่วงจำนวนสินค้าไม่ถูกต้อง',
  shipping_invalid_weight_range: 'ช่วงน้ำหนักสินค้าไม่ถูกต้อง',
  shipping_invalid_rate: 'ค่าจัดส่งไม่ถูกต้อง',
  shipping_invalid_offer_free_shipping_rate: 'ราคาไม่ถูกต้อง',
  shipping_and_more_range: 'ขึ้นไป',
  shipping_range_limit: 'จำกัด {limit} ช่วง',
  shipping_rate_placeholder: 'เช่น 1000.00',
  shipping_require_name: 'กรุณากรอกชื่อการจัดส่ง',
  shipping_invalid_data: 'ข้อมูลไม่ถูกต้อง',
  shipping_region_list_setting: 'รายชื่อพื้นที่จัดส่ง',
  payment_not_support_feature: 'แพ็กเกจปัจจุบันของคุณไม่สามารถใช้งานฟีเจอร์นี้ได้',
  accept_credit_card: 'รองรับบัตรเครดิต',
  paypal: 'PayPal',
  omise: 'Omise',
  rshop_manual: 'คู่มือการใช้งาน R-Shop',
  menu_export: 'ส่งออก',
  tooltip_menu_export: 'ส่งออกรายการสั่งซื้อ',
  tooltip_menu_order: 'จัดการสถานะรายการสั่งซื้อ',
  tooltip_menu_product: 'จัดการสินค้า',
  tooltip_menu_setting: 'ตั้งค่าระบบ',
  order_pointspot_discount: 'ส่วนลดจาก Pointspot',
  shipping_area_defined: 'กำหนดพื้นที่จัดส่ง',
  shipping_area_other: 'พื้นที่อื่นๆ',
  shipping_courntry_type: 'ประเทศ',
  shipping_thai_province_type: 'จังหวัดในประเทศไทย',
  other_country: 'ประเทศอื่นๆ',
  other_thai_province: 'จังหวัดอื่นๆในประเทศไทย',
  shipping_other_area_all_province: 'ทุกจังหวัดยกเว้นจังหวัดที่ระบุไว้ในพื้นที่จัดส่ง',
  shipping_area_type: 'ประเภทพื้นที่จัดส่ง',
  country_name_list: 'รายชื่อประเทศ',
  province_name_list: 'รายชื่อจังหวัด',
  select_province: 'เลือกจังหวัด',
  no_province_result: 'ไม่พบจังหวัดที่ค้นหา',
  display_not_specify: 'ยังไม่ได้ระบุ',
  change_shipping_type_confirm_description: 'ยืนยันการเปลี่ยนแปลงประเภทพื้นที่จัดส่ง จาก <b>[change_from]</b> เป็น <b>[change_to]</b>',
  order_pointspot_receive_point: 'จำนวนพอยท์ที่ได้รับจาก Pointspot',
  sorting_option_setting: 'การจัดเรียง',
  sorting_option_product_category: 'หมวดหมู่สินค้า',
  sorting_option_product: 'สินค้า',
  sorting_option_sort_by: 'จัดเรียงตาม',
  edit_product_sorting: 'แก้ไขการจัดเรียงสินค้า',
  edit_category_sorting: 'แก้ไขการจัดเรียงหมวดหมู่สินค้า',
  affect_to_label: 'ให้มีผลกับ',
  all_products_list: 'รายการทั้งหมด',
  new_products_list: 'รายการที่จะถูกสร้างใหม่',
  all_category_list: 'รายการทั้งหมด',
  new_category_list: 'รายการที่จะถูกสร้างใหม่',
  all_categories_sort_label: 'เรียงตาม',
  sort_category: 'เรียงหมวดหมู่',
  publish_sort_category_action_suggest: 'ใช้การจัดเรียงนี้เป็นค่าเริ่มต้นบนหน้าเว็บไซต์',
  publish_sort_category_btn: 'เผยแพร่',
  product_advance_search_status: 'สถานะ',
  product_advance_search_status_show: 'แสดง',
  product_advance_search_status_hide: 'ซ่อน',
  not_defined: 'ไม่ระบุ',
  products_card_move_to_first: 'ย้ายไปเป็นลำดับแรก',
  products_card_move_to_last: 'ย้ายไปเป็นลำดับสุดท้าย',
  products_card_move_to_specific_target: 'ย้ายไปเป็นลำดับที่กำหนดเอง',
  products_sorting_waiting_to_publish: 'ใช้การจัดเรียงนี้เป็นค่าเริ่มต้นบนหน้าเว็บไซต์',
  products_in_this_category_label: 'เฉพาะในหมวดหมู่นี้',
  products_under_category_label: 'ทั้งหมดรวมหมวดหมู่ย่อย',
  sort_product_btn: 'จัดเรียงสินค้า',
  no_category_childs_label: 'ไม่พบหมวดหมู่ย่อยภายใต้หมวดหมู่นี้',
  products_card_move_after: 'ต่อท้ายสินค้าลำดับที่',
  error_product_order_range: 'กรุณาระบุลำดับตั้งแต่ 1 - {max}',
  product_sorting_title: 'จัดเรียงสินค้า',
  product_sorting_newest: 'สินค้าใหม่ไปเก่า',
  product_sorting_oldest: 'สินค้าเก่าไปใหม่',
  product_sorting_name_asc: 'ชื่อสินค้า ก-ฮ',
  product_sorting_name_desc: 'ชื่อสินค้า ฮ-ก',
  product_sorting_price_asc: 'ราคาสินค้าน้อยไปมาก',
  product_sorting_price_desc: 'ราคาสินค้ามากไปน้อย',
  category_sorting_newest: 'หมวดหมู่ใหม่ไปเก่า',
  category_sorting_oldest: 'หมวดหมู่เก่าไปใหม่',
  category_sorting_name_asc: 'ชื่อหมวดหมู่ ก-ฮ',
  category_sorting_name_desc: 'ชื่อหมวดหมู่ ฮ-ก',
  product_filter_max: 'ไม่เกิน',
  product_filter_min: 'ตั้งแต่',
  product_filter_equal: 'เท่ากับ',
  upload_image_multiple_select: 'อัพโหลดได้ครั้งละหลายรูป',
  upload_image_multiple_recommend_image_size: 'ขนาดรูปที่แนะนำ {image_size}',
  upload_image_multiple_recommend_file_size: 'ขนาดไฟล์ไม่เกิน {file_size}',
  upload_image_multiple_max_number_of_files: 'จำนวนสูงสุด {number} รูป',
  payment_method_type_transfer: 'โอนเงิน',
  payment_method_type_cash: 'เก็บเงินปลายทาง',
  payment_method_type_other: 'อื่นๆ',
  payment_setting_type: 'ประเภท',
  payment_setting_channel: 'ช่องทาง',
  payment_setting_methods: 'ช่องทาง',
  payment_setting_channel_placeholder: 'ชื่อธนาคาร เลขที่บัญชี / พร้อมเพย์ เบอร์โทร',
  payment_setting_description: 'รายละเอียด',
  payment_setting_description_placeholder: 'ชื่อบัญชี / รายละเอียดเพิ่มเติม',
  payment_setting_show_payment_evidence: 'แสดงปุ่มส่งหลักฐานการชำระเงิน',
  payment_setting_show_payment_evidence_yes: 'แสดง',
  payment_setting_show_payment_evidence_no: 'ไม่แสดง',
  cannot_remove_last_image: 'ไม่สามารถลบรูปสุดท้ายได้',
  shipping_pricing: 'ค่าจัดส่ง',
  shipping_service: 'บริการจัดส่ง',
  product_variant_image_upload_not_save: 'กรุณาบันทึกตัวเลือกย่อยของสินค้าก่อนอัปโหลดรูป',
  order_update_date: 'วันที่สั่งซื้อ',
  order_status: 'สถานะ',
  order_type_merchant: 'สร้างโดยร้านค้า',
  order_status_new: 'ใหม่',
  order_status_confirm: 'รอชำระ',
  order_status_paid: 'ชำระแล้ว',
  order_status_delivering: 'ระหว่างจัดส่ง',
  order_status_delivered: 'ถึงมือผู้รับ',
  order_advance_search_between: 'ระหว่าง',
  btn_add_order: 'สร้างรายการสั่งซื้อ',
  order_status_detail: 'สถานะการสั่งซื้อ',
  order_tracking_number: 'เลขที่จัดส่ง',
  order_delivered_date: 'วันที่จัดส่ง',
  order_check_tracking: 'ตรวจสอบ',
  new_order_header: 'สร้างรายการสั่งซื้อ',
  edit_order_header: 'แก้ไขรายการสั่งซื้อ',
  order_url: 'ลิงก์รายการสั่งซื้อ',
  order_district: 'อำเภอ',
  order_sub_district: 'ตำบล',
  btn_new_order_save: 'บันทึก',
  add_new_product: 'เพิ่มรายการสินค้า',
  add_product_search: 'ชื่อสินค้า, SKU',
  add_product_successful: 'เพิ่มสินค้าสำเร็จ',
  add_product_failed: 'สินค้านี้ถูกเพิ่มแล้ว',
  add_new_order_alert: 'กรุณาเพิ่มสินค้าอย่างน้อย 1 รายการ',
  order_address_line2: 'ที่อยู่บรรทัดที่ 2',
  btn_copy_order_url: 'คัดลอกลิงก์รายการสั่งซื้อ',
  alert_copy_success: 'คัดลอกสำเร็จ',
  validatefail_product_sales_value: 'ค่าเริ่มต้นไม่ถูกต้อง',
  product_sales_label: 'จำนวนสินค้าที่ขายไปแล้ว',
  product_sold_label: 'ขายได้จริง',
  product_sold_display: 'จำนวนที่แสดง',
  not_add_product_label: 'ยังไม่ได้เพิ่มรายการสินค้า',
  product_sold_default_label: 'ค่าเริ่มต้น',
  menu_order_list: 'รายการ',
  tooltip_menu_order_list: 'รายการสั่งซื้อ',
  add_new_product_search_alert_label: 'กรุณาระบุข้อความ',
  label_order_country_select: 'เลือกประเทศ',
  label_order_province_select: 'เลือก จังหวัด',
  label_order_district_select: 'เลือก เขต/อำเภอ',
  label_order_sub_district_select: 'เลือก แขวง/อำเภอ',
  label_btn_delete_product_mobile: 'ลบสินค้า',
  label_total_product_product_mobile: 'รวมทั้งหมด',
  label_btn_create_in_chat_order: 'สร้าง In-Chat ออเดอร์',
  label_in_chat_order: 'In-Chat ออเดอร์',
  label_normal: 'ปกติ',
  label_btn_copy_order_in_chat_url: 'คัดลอกลิงก์ไปส่งในห้องแชท',
  label_address_toggle: 'ข้อมูลที่อยู่',
  label_product_over_stock_alert: 'จำนวนสินค้าไม่เพียงพอ',
  order_total_table: 'ทั้งหมด',
  order_total_table_header: 'รวมราคา',
  error_product_order_variant_empty: 'กรุณาระบุตัวเลือกย่อยสินค้า',
  order_address_line1: 'ที่อยู่บรรทัดที่ 1',
  label_product_over_stock_alert_not_correct: 'กรุณาระบุจำนวนสินค้าให้ถูกต้อง',
  pricing_model_per_unit: 'ราคาต่อชิ้น',
  pricing_model_tier: 'ตามลำดับขั้น',
  pricing_model_unit: 'ราคาสินค้าต่อชิ้น',
  pricing_model_volume: 'ราคาสินค้าตามจำนวน',
  label_pricing_model: 'รูปแบบการกำหนดราคา',
  pricing_volume_range: 'ช่วงจำนวน',
  pricing_tier_range: 'ช่วงจำนวน',
  above: 'ขึ้นไป',
  edit_order_status: 'แก้ไขสถานะ',
  open_rcrm_order_detail: 'ดูรายละเอียด',
  product_step_price_add_range: 'เพิ่ม',
  price_volume_variants_affected_warning: 'ตัวเลือกย่อยของสินค้า จะใช้งานราคาที่ตั้งค่าไว้ด้านล่างนี้โดยอัตโนมัติ',
  price_volume_range_error_message: 'ช่วงจำนวนสินค้าไม่ถูกต้อง',
  price_volume_prices_error_message: 'ราคาสินค้าไม่ถูกต้อง',
  order_details: 'รายการสั่งซื้อ',
  not_specified: 'ไม่ระบุ',
  product_list_product_variants: 'มีตัวเลือกย่อยของสินค้า',
  variant_setting_title_change_page_modal: 'คุณกำลังเปลี่ยนหน้าโดยไม่ได้บันทึกการตั้งค่า ?',
  variant_setting_title_change_tab_modal: 'คุณกำลังเปลี่ยนแท็บโดยไม่ได้บันทึกการตั้งค่า ?',
  variant_setting_confirm_change_page_modal: 'ใช่ ไม่บันทึก',
  save_basic_setting_button: 'บันทึกการตั้งค่าเบื้องต้น',
  save_variant_setting_button: 'บันทึกตัวเลือกย่อย',
  add_new_order_quantity_alert: 'กรุณาตรวจสอบจำนวนและราคาสินค้าให้ถูกต้อง'
}



// WEBPACK FOOTER //
// ./src/store/i18n/th.js